import { useTranslation } from '../store';

const Loading = ({ message }: { message?: string }) => {
  const { t } = useTranslation();

  return (
    <div className="tab-content">
      <div className="loading">{message || t('loading')}</div>
    </div>
  );
};

export default Loading;